var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import Dropzone from "react-dropzone";
import { H4 } from "@irati/ui/src/Headings";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { DropzoneWrapper, Img } from "./styled";
import addAFile from "../../images/add-a-file.png";
var DragAndDrop = /** @class */ (function (_super) {
    __extends(DragAndDrop, _super);
    function DragAndDrop() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DragAndDrop.prototype.render = function () {
        var _a = this.props, onDrop = _a.onDrop, formatMessage = _a.formatMessage;
        return (React.createElement(DropzoneWrapper, null,
            React.createElement(Dropzone, { className: "styledDropzone", accept: ".csv", multiple: false, onDrop: onDrop },
                React.createElement(Img, { src: addAFile, alt: formatMessage({ id: "platform.dragAndDrop.img.alt" }) }),
                React.createElement(H4, { small: true },
                    React.createElement(FormattedMessage, { id: "platform.dragAndDrop.text", values: {
                            browse: React.createElement("b", { style: { textDecoration: "underline", cursor: "pointer" } },
                                React.createElement(FormattedMessage, { id: "platform.dragAndDrop.browse" }))
                        } })))));
    };
    return DragAndDrop;
}(Component));
export default injectIntl(DragAndDrop);
